import { Controller } from "@hotwired/stimulus"
import { debounce } from "../util"

// Connects to the data-controller="dialogs-search"
export default class extends Controller {
  static targets = ["form", "input", "hiddenInput", "clearButton"]

  connect() {
    this.inputTarget.addEventListener("input", debounce(this.search.bind(this), 500))
    this.inputTarget.addEventListener("input", this.updateClearButtonVisibility.bind(this))
  }

  search() {
    this.hiddenInputTarget.value = this.inputTarget.value
    this.submitFilter()
  }

  clear() {
    this.hiddenInputTarget.value = ""
    this.inputTarget.value = ""
    this.submitFilter()
    this.updateClearButtonVisibility()
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }

  updateClearButtonVisibility() {
    this.clearButtonTarget.classList.toggle("hidden!", !this.inputTarget.value.length)
  }

  submitFilter() {
    this.formTarget.requestSubmit()
  }
}
